import React, {useState, useCallback, useEffect, useRef, useMemo} from 'react';
import {useMediaQuery} from 'react-responsive';
import {connect} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';

import './RestaurantPage.less';

import Config from '../../../config';
import {DialogManager} from 'dialog-layout/dialog-manager/DialogManager';
import {Layout} from 'new-components/layout/Layout';
import {HeroImage} from 'elements/hero-image/HeroImage';
import {RestaurantInfo} from 'compositions/restaurant-info/RestaurantInfo';
import {RestaurantNavigation} from 'compositions/restaurant-navigation/RestaurantNavigation';
import {CategoryList} from 'compositions/category-list/CategoryList.tsx';
import {Initial, INITIAL_POPUP} from 'new-components/popups/initial/Initial';
import {MinicartTrigger} from 'compositions/minicart-trigger/MinicartTrigger';
import {Minicart, MINICART_POPUP} from 'compositions/minicart/Minicart';
import {SELECT_LOCATION_POPUP, SelectLocation} from "new-components/popups/select-location/SelectLocation";
import {largeScreenMediaQuery} from "new-constants/common.constants";
import {setCurrentRestaurant} from "new-actions/app-state.actions";
import {
	addMenuEntryToCart,
	changeOrderLineModifiers,
	decOrderLineQuantity,
	incOrderLineQuantity
} from "new-actions/order-line.actions.ts";
import {
	CART_MODIFIER_GROUP_EDIT_POPUP,
	MODIFIER_GROUP_EDIT_POPUP,
	ModifierGroupEdit
} from "new-components/popups/modifier-group-edit/ModifierGroupEdit";
import {getMenuEntry} from "helpers/menu.helper";
import {getDefaultModifierSelections} from "helpers/modifier.helper";
import {setOrderTypeInitial} from "new-actions/ordering-mode.actions";
import {getCartTotal, getTipAmount, isMenuEntryCompatibleWithCart} from "helpers/purchase.helper.ts";
import {Phone, PHONE_POPUP} from "new-components/popups/phone/Phone";
import {VERIFICATION_CODE_POPUP, VerificationCode} from "new-components/popups/verification-code/VerificationCode";
import {
	confirmPhone,
	confirmPhoneCode, confirmSetGuest,
	selectLanguage,
	setEmailMarketingConsent,
	setSmsMarketingConsent,
} from "new-actions/customer.actions";
import {Orders, ORDERS_POPUP} from "new-components/popups/orders/Orders";
import {Profile, PROFILE_POPUP} from "new-components/popups/profile/Profile";
import {Settings, SETTINGS_POPUP} from "new-components/popups/settings/Settings";
import {Name, NAME_POPUP} from "new-components/popups/name/Name";
import {Email, EMAIL_POPUP} from "new-components/popups/email/Email";
import {Birthday, BIRTHDAY_POPUP} from "new-components/popups/birthday/Birthday";
import {Offers, OFFERS_POPUP} from "new-components/popups/offers/Offers";
import {Cashpoints, CASHPOINTS_POPUP} from "new-components/popups/cashpoints/Cashpoints";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Card} from "elements/card/Card.tsx";
import {Block} from "compositions/block/Block.tsx";
import {DialogStack} from "dialog-layout/dialog-stack/DialogStack";
import {SELECT_LANGUAGE_POPUP, SelectLanguage} from "new-components/popups/select-language/SelectLanguage";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {
	CashPointsDefaultName,
	MainCategoryTypes,
	OrderingTypes,
	PaymentTypes,
	PhoneCodes,
	TermsStatuses
} from "new-constants/common.constants";
import {
	ACCEPT_TERMS,
	CHECK_PHONE_CODE,
	DISCOUNT,
	EMAIL_RECEIPTS, ORDER_DATES, ORDER_TIME_SLOTS,
	RESEND_PHONE_CODE,
	RESTAURANT_LIST_BY_ZIP,
	SERVER_CONFIG,
	SET_BIRTHDATE,
	SET_EMAIL, SET_GUEST,
	SET_NAME,
	SET_PHONE
} from "new-constants/api.constants";
import {
	cancelMinicart,
	cancelPhone,
	cancelSelectLocation,
	cancelVerificationCode,
	openMinicart,
	openPhone,
	openSelectLocation,
	openOrders,
	cancelOrders,
	openProfile,
	cancelProfile,
	openSettings,
	cancelSettings,
	openName,
	doneName,
	cancelName,
	openEmail,
	cancelEmail,
	doneEmail,
	openBirthday,
	doneBirthday,
	cancelBirthday,
	openOffers,
	cancelOffers,
	openCashpoints,
	cancelCashpoints,
	doneSelectLanguage,
	openSelectLanguage,
	cancelSelectLanguage,
	openInitial,
	cancelInitial,
	openModifierGroupEdit,
	cancelModifierGroupEdit,
	cancelDeliveryAddress,
	doneDeliveryAddress,
	cancelZipEdit,
	doneZipEdit,
	openCartModifierGroupEdit,
	cancelCartModifierGroupEdit,
	openDeleteCard,
	cancelRestaurantClosedErrorMessage,
	openLogoutConfirmation,
	cancelLogoutConfirmation,
	doneLogoutConfirmation,
	openEmailAllReceipts,
	doneEmailAllReceipts,
	cancelEmailAllReceipts,
	confirmVerificationCodeResend,
	cancelResendVerificationCodeMessage,
	cancelModifiersValidationErrorMessage,
	openNotifications,
	cancelNotifications,
	openCardStatus,
	doneCardStatus,
	cancelCardStatus,
	openDebug,
	cancelDebug,
	cancelIncompatibleCartConfirmation,
	doneIncompatibleCartConfirmation,
	cancelProfileStripeCardRegistration,
	cancelTerms,
	doneTerms,
	openLocationPermissionConfirmation,
	doneLocationPermissionConfirmation,
	cancelLocationPermissionConfirmation,
	cancelMobilePayReturnNoStateErrorMessage,
	openGuestOrderPopup,
	cancelGuestOrderPopup,
	openInitialOrderPopup,
	cancelInitialOrderPopup
} from "new-actions/popup.actions";
import {
	getAvailableOrderingTypesSelector,
	getCartItemsSelector,
	getCurrentAppIdSelector,
	getCurrentCashpointsSelector,
	getCurrentCustomerSelector,
	getCurrentFilteredRestaurantListSelector,
	getCurrentMenuSelector,
	getCurrentPurchaseSelector,
	getCurrentRestaurantIdSelector,
	getCurrentRestaurantListSelector,
	getCurrentRestaurantSelector,
	getCurrentServerConfig,
	getCurrentServerPopupsSelector,
	getCurrentServerValuesSelector,
	getDeliveryConditionsSelector,
	getTipAmountSelector,
	getTranslationsSelector,
	getCurrentActiveOrdersSelector,
	getCurrentHistoryOrdersSelector,
	getCurrentTemporaryOrderIdSelector,
	getCurrentDeliveryAddressSelector,
	getCurrentDefaultTakeAwayItemsAddedSelector, getCurrentGuestSelector
} from "../../../selectors";
import {DELIVERY_ADDRESS_POPUP, DeliveryAddress} from "new-components/popups/delivery-address/DeliveryAddress";
import {BackButton} from "elements/back-button/BackButton";
import {checkout} from "new-actions/navigation.actions";
import {ZIP_EDIT_POPUP, ZipEdit} from "new-components/popups/zip-edit/ZipEdit";
import {getRegistrationPopup} from "helpers/customer.helper";
import {Offline} from "new-components/popups/offline/Offline";
import {
	getScheduleString,
	isNotPossibleToChooseTime,
	isRestaurantDineIn,
	isRestaurantOpen
} from "helpers/restaurant.helper";
import {
	DISCOUNT_ERROR_MESSAGE_POPUP, ErrorMessage,
	RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP
} from "new-components/popups/error-message/ErrorMessage";
import {MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP} from 'new-components/popups/error-message/ErrorMessage'
import {Button} from "elements/button/Button";
import {
	Confirmation,
	INCOMPATIBLE_CART_CONFIRMATION_POPUP, LOCATION_PERMISSION_CONFIRMATION_POPUP,
	LOGOUT_CONFIRMATION_POPUP
} from "new-components/popups/confirmation/Confirmation";
import {EMAIL_ALL_RECEIPTS_POPUP, EmailReceipt} from "new-components/popups/email-receipt/EmailReceipt";
import {ADD_MENU_ENTRY_TO_CART} from "new-constants/order-line.constants";
import {Notifications, NOTIFICATIONS_POPUP} from "new-components/popups/notifications/Notifications";
import {getCartDiscount} from "helpers/order-line.helper.ts";
import {CARD_STATUS_POPUP, CardStatus} from "new-components/popups/card-status/CardStatus";
import {Debug, DEBUG_POPUP} from "new-components/popups/debug/Debug";
import {
	PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
	StripeCardRegistration
} from "new-components/popups/stripe-card-registration/StripeCardRegistration";
import {profileStripeError, profileStripeSuccess} from "new-actions/payment.actions";
import {TranslationsContext} from "contexts/translations-context";
import {Terms, TERMS_POPUP} from "new-components/popups/terms/Terms";
import {isPossibleToRequestLocationPermission} from "helpers/permission.helper";
import {DialogOverlay} from "dialog-layout/dialog-overlay/DialogOverlay";
import {CartDisplay} from "compositions/cart-display/CartDisplay";
import {convertPrice} from "helpers/format.helper";
import {CheckoutButton} from "compositions/checkout-button/CheckoutButton";
import {Drawer} from "dialog-layout/drawer/Drawer";

import {addToHomeScreenFromSettings} from "../../../actions/pwa.actions";
import {ADD_TO_HOME_SCREEN_POPUP, AddToHomeScreen} from "../../popups/add-to-home-screen/AddToHomeScreen";
import {
	cancelAddToHomeScreen,
	cancelAdyenCardCheckPaymentErrorMessagePopup,
	cancelAdyenCardRegistration,
	cancelDiscountErrorMessage,
	cancelMobilePayOrderCancelledErrorMessage,
	cancelMobilePayReturnNoUrlErrorMessage,
	cancelRepeatOrderConfirmation,
	cancelRepeatOrderErrorMessage,
	cancelRepeatOrderFromHistoryConfirmation,
	cancelRepeatOrderMessage,
	doneAddToHomeScreen, doneMobilePayAnonymousInfo,
	doneMobilePayReturnNoStateErrorMessage,
	doneRepeatOrderConfirmation,
	doneRepeatOrderFromHistoryConfirmation,
	doneServerPopup, doneSlowServiceCaption,
	openRepeatOrderConfirmation,
	openRepeatOrderFromHistoryConfirmation
} from "../../../actions/popup.actions";
import {isPWAInstallAvailable} from "../../../helpers/pwa-helper";
import {ScrollAnchor} from "../../elements/scroll-anchor/ScrollAnchor";
import {StickyElementTop} from "../../compositions/sticky-element-top/StickyElementTop";
import {MenuNavigation} from "../../compositions/menu-navigation/MenuNavigation";
import {BlockTitle} from "../../elements/block-title/BlockTitle";
import {setInfoMessage, setJsError} from "../../../managers/client-log.manager";
import {LoadingSpinner} from "../../elements/loading-spinner/LoadingSpinner.tsx";
import {openExternalLink, openMenuEntryLink, openRestaurantLink} from "../../../actions/link.actions";
import {ServerPopupContainer} from "../../popups/server-popup/ServerPopup.container";
import {AllergensPopup} from "../../popups/allergens-popup/AllergensPopup";
import {ModifierDescription} from "../../popups/modifer-description/ModifierDescription";
import {openOrder} from "../../../actions/navigation.actions";
import {CHECK_ADYEN_PAYMENT, CHECK_PAYMENT_STATUS, REGISTER_ADYEN_CARD, REPEAT_ORDER} from "../../../constants/api.constants";
import {getModifierSelectionsFilteredByIds, getModifierValidationErrors} from "../../../helpers/modifier.helper";
import {
	ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP,
	MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP,
	REPEAT_ORDER_ERROR_MESSAGE_POPUP
} from "../../popups/error-message/ErrorMessage";
import {
	REPEAT_ORDER_CONFIRMATION_POPUP,
	REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP
} from "../../popups/confirmation/Confirmation";
import {getOrderingTypeFromOrder} from "../../../helpers/order.helper";
import {getAboutRoute, getRestaurantRoute} from "../../../helpers/routes.helper";
import {trackEvent} from "../../../helpers/tracking.helpers";
import {
	ADYEN_CARD_REGISTRATION_POPUP,
	CAUTH_CLEAR_CUSTOMER_DATA_POPUP,
	GUEST_ORDER_POPUP,
	SLOW_SERVICE_POPUP
} from "../../../constants/popup.constants";
import {AdyenCardRegistration} from "../../popups/adyen-card-registration/AdyenCardRegistration";
import {submitAdyenCardAdditionalDetails, submitAdyenCardRegister} from "../../../actions/payment.actions";
import {doneCauthClearCustomerData} from "../../../actions/app-state.actions";
import {ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP} from "../../popups/adyen-mobile-pay-anonymous-info/AdyenMobilePayAnonymousInfo";
import {PickupTime} from "new-components/popups/pickup-time/PickupTime";
import {setPickerDate, setPickupDateTime} from "new-actions/order-time.actions";
import TagManager from 'react-gtm-module'
import ReactPixel from 'react-facebook-pixel';
import {GuestOrderPopup} from "../../popups/guest-order/GuestOrderPopup.jsx";
import {INITIAL_ORDER_POPUP, InitialOrderPopup} from "new-components/popups/inital-order-popup/InitialOrderPopup";
import {setPhone} from "new-actions/api.actions";



const RepeatOrderingTypeTranslations = {
	[OrderingTypes.pickup]: 'RepeatOrderConfirmation.pickupTypeName',
	[OrderingTypes.delivery]: 'RepeatOrderConfirmation.deliveryTypeName',
	[OrderingTypes.dineIn]: 'RepeatOrderConfirmation.dineInTypeName'
};

const RestaurantPage = ({
	currentRestaurantId,
	currentRestaurant,
	currentCustomer,
	currentMenu,
	currentRestaurantList,
	currentFilteredRestaurantList,
	currentPurchase,
	cancelDiscountErrorMessage,
	cartItems,
	currentActiveOrders,
	currentHistoryOrders,
	currentCashpoints,
	fetchError,
	fetchProgress,
	fetchMessage,
	popup,
	currentServerValues,
	currentDeliveryAddress,
	deliveryConditions,
	orderingMode,
	availableOrderingTypes,
	currentServerConfig,
	connectivity,
	orderTime,
	translations,
	payment,
	permission,
	location,
	tipAmount,
	pwaPrompt,
	loading,
	currentServerPopups,
	currentTemporaryOrderId,
	defaultTakeAwayItemsAdded,
	currentGuest,
	
	addMenuEntryToCart,
	incOrderLineQuantity,
	decOrderLineQuantity,
	setCurrentRestaurant,
	setOrderTypeInitial,
	confirmPhone,
	confirmPhoneCode,
	openSelectLocation,
	cancelSelectLocation,
	openMinicart,
	cancelMinicart,
	openPhone,
	cancelPhone,
	cancelVerificationCode,
	confirmVerificationCodeResend,
	openOrders,
	cancelOrders,
	openProfile,
	cancelProfile,
	openSettings,
	cancelSettings,
	openName,
	cancelName,
	doneName,
	openEmail,
	cancelEmail,
	doneEmail,
	openBirthday,
	cancelBirthday,
	doneBirthday,
	openOffers,
	cancelOffers,
	openCashpoints,
	cancelCashpoints,
	openSelectLanguage,
	cancelSelectLanguage,
	doneSelectLanguage,
	openInitial,
	openModifierGroupEdit,
	cancelModifierGroupEdit,
	openCartModifierGroupEdit,
	cancelCartModifierGroupEdit,
	changeOrderLineModifiers,
	cancelDeliveryAddress,
	doneDeliveryAddress,
	checkout,
	cancelZipEdit,
	doneZipEdit,
	openDeleteCard,
	cancelRestaurantClosedErrorMessage,
	openLogoutConfirmation,
	cancelLogoutConfirmation,
	doneLogoutConfirmation,
	openEmailAllReceipts,
	cancelEmailAllReceipts,
	doneEmailAllReceipts,
	cancelResendVerificationCodeMessage,
	cancelModifiersValidationErrorMessage,
	openNotifications,
	cancelNotifications,
	setEmailMarketingConsent,
	setSmsMarketingConsent,
	cancelInitial,
	openCardStatus,
	cancelCardStatus,
	doneCardStatus,
	openDebug,
	cancelDebug,
	cancelIncompatibleCartConfirmation,
	doneIncompatibleCartConfirmation,
	profileStripeSuccess,
	profileStripeError,
	cancelProfileStripeCardRegistration,
	cancelTerms,
	doneTerms,
	openLocationPermissionConfirmation,
	cancelLocationPermissionConfirmation,
	doneLocationPermissionConfirmation,
	addToHomeScreenFromSettings,
	doneAddToHomeScreen,
	cancelAddToHomeScreen,
	doneServer,
	openExternalLink,
	openRestaurantLink,
	openMenuEntryLink,
	openOrder,
	cancelRepeatOrderMessage,
	openRepeatOrderFromHistoryConfirmation,
	cancelRepeatOrderFromHistoryConfirmation,
	doneRepeatOrderFromHistoryConfirmation,
	cancelRepeatOrderErrorMessage,
	cancelMobilePayOrderCancelledErrorMessage,
	cancelMobilePayReturnNoStateErrorMessage,
	doneMobilePayReturnNoStateErrorMessage,
	cancelMobilePayReturnNoUrlErrorMessage,
	cancelAdyenCardRegistration,
	submitAdyenCardRegister,
	submitAdyenCardAdditionalDetails,
	cancelAdyenCardCheckPaymentErrorMessagePopup,
	doneCauthClearCustomerData,
	doneSlowServiceCaption,
	doneMobilePayAnonymousInfo,
	setPickerDate,
	setPickupDateTime,
	openGuestOrderPopup,
	cancelGuestOrderPopup,
	confirmSetGuest,
	openInitialOrderPopup,
	cancelInitialOrderPopup
}) => {
	//TODO replace CashPointsDefaultName constant with translation
	const {entryIdToExpand} = useParams();
	
	const [isPopupOpen, setPopupOpen] = useState(false);
	const [isSecondPopupOpen, setSecondPopupOpen] = useState(false);
	
	const [showServerPopup, setShowServerPopup] = useState(true);
	
	useEffect(() => {
		setShowServerPopup(true);
	}, [currentRestaurantId]);
	
	const [selectedMainCategoryIdClick, setSelectedMainCategoryIdClick] = useState({click: false, id: undefined});
	
	const defaultMainCategoryId = currentMenu?.menu.menu[0]?.id;
	const currentMainCategoryId = currentMenu?.menu.menu?.map(mainCategory => mainCategory.id).includes(selectedMainCategoryIdClick.id)
		? selectedMainCategoryIdClick.id : defaultMainCategoryId
	const currentMainCategoryIdClick = useMemo(() => selectedMainCategoryIdClick?.id ? selectedMainCategoryIdClick : {
		id: currentMainCategoryId,
		click: false,
	}, [selectedMainCategoryIdClick, currentMainCategoryId]);
	
	const selectedMainCategory = useMemo(
		() => currentMenu?.menu.menu.find(mainCategory => mainCategory.id === currentMainCategoryId),
		[currentMenu, currentMainCategoryId]
	);
	const [selectedCategoryIdClick, setSelectedCategoryIdClick] = useState({
		id: selectedMainCategory?.categories[0]?.id,
		click: false
	});
	
	//TODO extract modifier controlling logic to wrapping component
	const [editableModifierGroupId, setEditableModifierGroupId] = useState(null);
	const [expandedEntryId, setExpandedEntryId] = useState(null);
	const [editableEntryId, setEditableEntryId] = useState(null);
	const editableEntry = editableEntryId && getMenuEntry(currentMenu.menu.menu, editableEntryId);
	
	const [menuModifierSelections, setMenuModifierSelections] = useState({});
	const editableModifierGroup = editableModifierGroupId && currentMenu.menu.modifierGroups.find(
		modifierGroup => modifierGroup.modifierGroupId === editableModifierGroupId);
	
	const [editableCartModifierGroupId, setEditableCartModifierGroupId] = useState(null);
	const [editableCartItemToken, setEditableCartItemToken] = useState(null);
	const editableCartItem = editableCartItemToken && cartItems.find(cartItem => cartItem.token === editableCartItemToken);
	const editableCartItemMenuEntry = editableCartItem && getMenuEntry(currentMenu.menu.menu, editableCartItem.menuEntryId);
	const editableCartModifierGroup = editableCartModifierGroupId && currentMenu.menu.modifierGroups.find(
		modifierGroup => modifierGroup.modifierGroupId === editableCartModifierGroupId);
	
	const defaultModifierSelections = getDefaultModifierSelections(currentMenu?.menu.modifierGroups);
	
	const [allergens, setAllergens] = useState(null);
	const [modifierDescription, setModifierDescription] = useState(null);
	
	const [entryQuantities, setEntryQuantities] = useState({});
	
	const [currentOrder, setCurrentOrder] = useState({});
	const [isPickupTimePopupOpen, setPickupTimePopupOpen] = useState(false);
	const [shouldOpenCartOnLogin, setShouldOpenCartOnLogin] = useState(false);

	const history = useHistory();
	
	useEffect(() => {
		if (parseInt(entryIdToExpand)) {
			setExpandedEntryId(parseInt(entryIdToExpand));
			history.replace(getRestaurantRoute());
		}
	}, [entryIdToExpand]);
	
	useEffect(() => {
		if (!currentMenu?.menu?.menu || !currentCustomer?.phone) {
			return;
		}
		const menuModifierGroups = currentMenu.menu.modifierGroups;
		const menus = currentMenu.menu.menu;
		let categories = [];
		let entries = [];
		menus.forEach(menu => {
			categories = [...categories, ...menu.categories];
		})
		categories.forEach(category => {
			entries = [...entries, ...category.entries];
		});
		const defaultTakeAwayEntries = entries.filter(
			entry => entry.isDefaultTakeawayItem && !cartItems?.find(item => item.menuEntryId === entry.id) && !defaultTakeAwayItemsAdded?.find(
				id => id === entry.id));
		defaultTakeAwayEntries.forEach(entry => {
			const modifierGroups = menuModifierGroups
			.filter(modifierGroup => entry.modIds && entry.modIds.includes(modifierGroup.modifierGroupId))
			.sort((modifierGroup1, modifierGroup2) => entry.modIds.indexOf(modifierGroup1.modifierGroupId) - entry.modIds.indexOf(
				modifierGroup2.modifierGroupId));
			addMenuEntryToCart(
				currentRestaurantId,
				entry.id,
				1,
				getDefaultModifierSelections(modifierGroups),
				false,
				false,
				[],
				true
			);
		});
		
	}, [currentCustomer]);
	
	const isLargeScreen = useMediaQuery({query: largeScreenMediaQuery});
	
	const closeModifierGroupEdit = () => {
		cancelModifierGroupEdit();
		trackEvent({
			event: 'Close Modifier Group Edit',
			properties: {
				'Venue Id': currentRestaurant.restaurantId,
			}
		});
		setEditableModifierGroupId(null);
	}
	const openNextModifierGroupEdit = () => {
		const nextModifierGroupIdIndex = editableEntry.modIds.indexOf(editableModifierGroupId) + 1;
		setEditableModifierGroupId(editableEntry.modIds[nextModifierGroupIdIndex]);
	}
	
	const closeCartModifierGroupEdit = () => {
		cancelCartModifierGroupEdit();
		setEditableCartModifierGroupId(null);
		setEditableCartItemToken(null);
	}
	
	const openNextCartModifierGroupEdit = () => {
		const nextModifierGroupIdIndex = editableCartItemMenuEntry.modIds.indexOf(editableCartModifierGroupId) + 1;
		setEditableCartModifierGroupId(editableCartItemMenuEntry.modIds[nextModifierGroupIdIndex]);
	}

	const gtmTrackAddToCart = (entryId, quantity) => {
		if(currentServerConfig?.googleTagManagerId && currentOrder) {
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}
			gtag('event', 'add_to_cart', {
				entry_id: entryId,
				quantity: quantity
			});
		}
	}

	const fbPixelTrackAddToCart = (entryId, quantity) => {
		if(currentServerConfig?.facebookPixelId && currentOrder) {
			ReactPixel.trackCustom('add_to_cart', {
				entry_id: entryId,
				quantity: quantity
			});
		}
	}
	
	const onAddClick = useCallback((e, entryId, quantity, modifierSelections, modifierValidationErrors, isDefaultTakeAwayItem = false) => {
		e?.stopPropagation();
		if (!currentCustomer?.restaurant || !currentRestaurant) {
			setJsError(`Restaurant is empty when adding to cart ${currentCustomer?.restaurant} ${currentRestaurant}`);
		}
		const restaurantClosedPopup = (!isRestaurantOpen(currentCustomer, currentRestaurant) || isNotPossibleToChooseTime(currentRestaurant, orderTime))
			&& RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP;
		
		if (restaurantClosedPopup) {
			setInfoMessage(`Restaurant closed popup: 
				isRestaurantOpen=${isRestaurantOpen(currentCustomer, currentRestaurant)} | 
				isNotPossibleToChooseTime=${isNotPossibleToChooseTime(currentRestaurant, orderTime)} | 
				isOpen=${currentCustomer?.restaurant?.isOpen} | 
				isTemporaryStopOrders=${currentCustomer?.restaurant?.isTemporaryStopOrders} | 
				isTooBusyForNewOrders=${currentCustomer?.restaurant?.isTooBusyForNewOrders}
			`)
		}
		
		const registrationPopup = getRegistrationPopup(currentCustomer, currentRestaurant);
		const incompatibleCartPopup = !isMenuEntryCompatibleWithCart(entryId, cartItems, currentMenu) && INCOMPATIBLE_CART_CONFIRMATION_POPUP;
		const modifiersValidationErrorMessagePopup = modifierValidationErrors?.length > 0 && MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP;
		
		const blockingPopup = restaurantClosedPopup || modifiersValidationErrorMessagePopup;
		const postponingPopup = registrationPopup || incompatibleCartPopup;
		addMenuEntryToCart(
			currentRestaurantId,
			entryId,
			quantity,
			modifierSelections,
			blockingPopup,
			postponingPopup,
			modifierValidationErrors,
			isDefaultTakeAwayItem
		);
		if (!blockingPopup) {
			setMenuModifierSelections({
				...menuModifierSelections,
				[entryId]: null
			});
			setEntryQuantities({
				...entryQuantities,
				[entryId]: 1,
			});
		}

		gtmTrackAddToCart(entryId, quantity);
		fbPixelTrackAddToCart(entryId, quantity);

	}, [
		openPhone,
		addMenuEntryToCart,
		currentCustomer,
		currentRestaurant,
		cartItems,
		currentMenu,
		orderTime,
		entryQuantities
	]);
	
	const onModifierGroupClick = useCallback((e, modifierGroupId, menuEntryId) => {
		e.stopPropagation();
		openModifierGroupEdit();
		setEditableModifierGroupId(modifierGroupId);
		setEditableEntryId(menuEntryId);
	}, [openModifierGroupEdit]);
	
	const onAllergensClick = useCallback((entryAllergens, event, entryId) => {
		trackEvent({
			event: 'Click On Allergens', properties: {
				'Venue Id': currentRestaurantId,
				'Menu Entry Id': entryId,
			}
		});
		event.stopPropagation();
		setAllergens(entryAllergens);
	}, []);
	
	const onEntryClick = useCallback((e, entryId) => {
		trackEvent({
			event: 'Click On Entry', properties: {
				'Venue Id': currentRestaurantId,
				'Entry Id': entryId,
			}
		});
		expandedEntryId === entryId ? setExpandedEntryId(null) : setExpandedEntryId(entryId);
	}, [expandedEntryId]);
	
	const onModifierDescriptionClick = (description, event) => {
		event.stopPropagation();
		setModifierDescription(description);
	};
	
	const onOrderingTypeClick = useCallback((orderingType) => {
		setOrderTypeInitial(orderingType, currentRestaurantList);
	}, [setOrderTypeInitial, currentRestaurantList.length])
	
	const onMainCategoryVisible = (isVisible, mainCategoryId) => {
		if (!isVisible) {
			return;
		}
		setSelectedMainCategoryIdClick({
			id: mainCategoryId,
			click: false,
		});
	}
	
	const onMainCategoryClick = useCallback(mainCategoryId => setSelectedMainCategoryIdClick({
		id: mainCategoryId,
		click: true
	}), []);
	
	const onCategoryVisible = useCallback((isVisible, categoryId) => {
		if (!isVisible) {
			return;
		}
		setSelectedCategoryIdClick({id: categoryId, click: false});
		currentMenu.menu.menu.forEach(mainCategory => {
			if (mainCategory.categories.map(category => category.id).indexOf(categoryId) >= 0) {
				setSelectedMainCategoryIdClick({id: mainCategory.id, click: false});
			}
		})
	}, [currentMenu]);
	
	const onCategoryClick = useCallback(categoryId => setSelectedCategoryIdClick({
		id: categoryId,
		click: true,
	}), []);
	
	const onEntryQuantityChange = useCallback((entryId, quantity) => {
		trackEvent({
			event: 'Change Entry Quantity', properties: {
				'Venue Id': currentRestaurantId,
				'Entry Id': entryId,
				'Quantity': quantity,
			}
		});
		setEntryQuantities({
			...entryQuantities,
			[entryId]: quantity,
		});
	}, [entryQuantities]);
	
	const onMoreClick = useCallback(() => history.push(getAboutRoute()), []);
	
	const onAddToCartFromModifierClick = (menuEntryId, quantity, menuModifierSelections) => {
		trackEvent({
			event: 'Add Item To Cart From Modifier', properties: {
				'Venue Id': currentRestaurantId,
				'Menu Entry Id': menuEntryId,
			}
		});
		const modIds = {
			...getModifierSelectionsFilteredByIds(defaultModifierSelections, editableEntry?.modIds),
			...menuModifierSelections[menuEntryId]
		};
		onAddClick(null, menuEntryId, quantity, modIds, getModifierValidationErrors(modIds, currentMenu?.menu.modifierGroups, translations));
		closeModifierGroupEdit();
		setExpandedEntryId(null);
	}
	
	const orderShortRestaurant = currentRestaurantList.find(restaurant => restaurant.restaurantId === currentOrder.restaurantId);
	const orderingType = getOrderingTypeFromOrder(currentOrder, orderShortRestaurant);
	const orderingClosedStrings = ['Ordering is closed', 'Bestilling er stengt', 'Det är stängt för beställningar', 'Bestilling er lukket'];
	const showPickupTimePopupOrderingClosed = (error) =>  {
		return orderingClosedStrings.map((str) => error.includes(str)).filter((item) => !!item).length > 0;
	}

	const onCheckout = (currentRestaurantId) => {
		const isCustomerLoggedIn = currentCustomer?.nickname?.length && currentCustomer?.phone?.length;
		if (isCustomerLoggedIn) {
			checkout(currentRestaurantId);
			return;
		}
		if (currentRestaurant.isUsingGuestFlow) {
			const isGuestLoggedIn = currentGuest?.phone?.length;
			if (!isGuestLoggedIn) {
				setShouldOpenCartOnLogin(true);
				openGuestOrderPopup();
			} else {
				checkout(currentRestaurantId);
			}
		} else {
			setShouldOpenCartOnLogin(true);
			openInitialOrderPopup();
		}
	}

	useEffect(() => {
			if(!currentServerConfig?.googleTagManagerId) {
				return;
			}
			const tagManagerArgs = {
				gtmId: currentServerConfig.googleTagManagerId
			};
			 
			TagManager.initialize(tagManagerArgs);
	}, [currentServerConfig]);

	useEffect(() => {
		if(!currentServerConfig?.facebookPixelId) {
			return;
		}
		const options = {
			autoConfig: true,
			debug: false,
		};
		ReactPixel.init(currentServerConfig.facebookPixelId, null, options);
	}, [currentServerConfig]);
	
	return (
		<TranslationsContext.Provider value={translations}>
			<Layout>
				
				<div className="restaurant-page">
					{
						!isLargeScreen && (
							<div className="restaurant-page__back">
								<BackButton onClick={openInitial}/>
							</div>
						)
					}
					<div className="restaurant-page__restaurant-image">
						<HeroImage src={currentRestaurant?.picture}/>
					</div>
					<header className="restaurant-page__restaurant-card">
						<RestaurantInfo
							iconSrc={currentServerConfig?.icon}
							name={currentRestaurant?.name}
							currentLocationName={
								currentRestaurant?.address || getScheduleString(
									currentFilteredRestaurantList.find(location => location.restaurantId === currentRestaurant?.restaurantId)?.todaySchedule,
									translations)
							}
							onLocationSelectClick={openSelectLocation}
							onMoreClick={onMoreClick}
							currentOrderingType={orderingMode.orderingType}
							isShowExpectedWait={currentRestaurant && !isRestaurantDineIn(currentRestaurant)}
							deliveryExpectedWait={currentRestaurant?.expectedWaitDelivery}
							deliveryPrice={deliveryConditions?.price}
							pickupExpectedWait={currentRestaurant?.expectedWaitPickup}
							smileyReportLink={currentRestaurant?.smileyUrl}
						/>
					</header>
					<nav className="restaurant-page__main-category-list" id={'main-cat-list-scroll'}>
						<StickyElementTop>
							{
								(isSticky) => {
									return (
										<MenuNavigation
											mainCategories={currentMenu?.menu.menu}
											selectedMainCategory={currentMainCategoryIdClick}
											isSticky={isSticky}
											onMainCategoryClick={onMainCategoryClick}
											categories={selectedMainCategory?.categories}
											selectedCategory={selectedCategoryIdClick}
											onCategoryClick={onCategoryClick}
										/>
									)
								}
							}
						</StickyElementTop>
					</nav>
					<main className="restaurant-page__category-list">
						{
							currentMenu?.menu.menu.map((mc) =>
								<React.Fragment key={mc.id}>
									<ScrollAnchor
										id={'main-cat-' + mc.id}
										selectedItemId={'main-cat-' + selectedMainCategoryIdClick.id}
										hasClick={selectedMainCategoryIdClick.click}
										key={mc.id}
										onVisible={(isVisible) => onMainCategoryVisible(isVisible, mc.id)}
									/>
									
									<div className="restaurant-page__main-category-name">
										<BlockTitle isLarge text={mc.name}/>
									</div>
									<CategoryList
										categories={mc?.categories}
										allModifierGroups={currentMenu?.menu.modifierGroups}
										menuModifierSelections={menuModifierSelections}
										onAddClick={onAddClick}
										selectedCategoryIdClick={selectedCategoryIdClick}
										onModifierGroupClick={onModifierGroupClick}
										isNotPossibleToOrder={mc?.type === MainCategoryTypes.info || mc?.notPossibleToOrder}
										onVisible={onCategoryVisible}
										expandedEntryId={expandedEntryId}
										onEntryClick={onEntryClick}
										onAllergensClick={onAllergensClick}
										entryQuantities={entryQuantities}
										onEntryQuantityChange={onEntryQuantityChange}
										cartNotEmpty={cartItems?.length > 0}
									/>
								</React.Fragment>
							)
						}
					
					</main>
					<aside className="restaurant-page__side-menu">
						<div className="restaurant-page__side-cart">
							<Block title={getSafeTranslation('RestaurantPage.cartBlockTitle', translations)}>
								<Card>
									<Minicart
										cartItems={cartItems}
										discount={getCartDiscount(cartItems, deliveryConditions, currentServerValues)}
										delivery={orderingMode?.orderingType === OrderingTypes.delivery && (deliveryConditions?.price || currentRestaurant?.deliveryPrice
											|| 0)}
										cashpoints={currentPurchase.useCashPoints && currentServerValues.cashpointsAmount}
										cashpointsName={(currentRestaurant?.cashPointsName) || CashPointsDefaultName}
										tip={tipAmount}
										totalPrice={getCartTotal(currentPurchase, currentServerValues, deliveryConditions, cartItems, tipAmount)}
										onCheckoutClick={() => onCheckout(currentRestaurantId)}
										onQuantityDecClick={token => decOrderLineQuantity(currentRestaurantId, token)}
										onQuantityIncClick={token => incOrderLineQuantity(currentRestaurantId, token)}
										onModifierGroupClick={(modifierGroupId, token) => {
											setEditableCartModifierGroupId(modifierGroupId);
											setEditableCartItemToken(token);
											openCartModifierGroupEdit();
										}}
									/>
								</Card>
							</Block>
						</div>
						<div className="restaurant-page__navigation">
							<Card isNoPaddings>
								<RestaurantNavigation
									onOrdersClick={() => openOrders(currentRestaurantId)}
									onProfileClick={openInitial}
								/>
							</Card>
						</div>
					</aside>
					{
						cartItems.length > 0 && (
							<footer className="restaurant-page__minicart">
								<MinicartTrigger
									total={getCartTotal(currentPurchase, currentServerValues, deliveryConditions, cartItems, tipAmount)}
									onClick={openMinicart}
								/>
							</footer>
						)
					}
					<DialogManager>
						<DialogStack>
							{isPopupOpen && (
								<DrawerPopup onOverlayClick={() => setPopupOpen(false)} key="drawer1">
									<div
										className="drawer-content"
										onClick={() => {
											setSecondPopupOpen(true);
											setPopupOpen(false);
										}}
									>
										First
									</div>
								</DrawerPopup>
							)}
							
							{isSecondPopupOpen && (
								<DrawerPopup key="drawer2" onOverlayClick={() => setSecondPopupOpen(false)}>
									<div className="drawer-content">Second</div>
								</DrawerPopup>
							)}
							{
								isPickupTimePopupOpen && (
									<PickupTime
										orderingMode={orderingMode}
										orderTime={orderTime}
										isFutureOrdersAllowed={currentRestaurant?.isFutureOrdersAllowed}
										error={
											`${fetchMessage[ORDER_DATES] || ''}\n
												${fetchError[ORDER_DATES] || ''}\n
										 		${fetchMessage[ORDER_TIME_SLOTS] || ''}\n
										 		${fetchError[ORDER_TIME_SLOTS] || ''}`
										}
										onDateClick={date => setPickerDate(date)}
										onOverlayClick={() => setPickupTimePopupOpen(false)}
										onCancelClick={() => setPickupTimePopupOpen(false)}
										onDoneClick={(date, time) => {
											setPickupTimePopupOpen(false);
											setPickupDateTime(date, time);
										}}
									/>
								)
							}
							{
								popup.includes(CASHPOINTS_POPUP) && (<Cashpoints
									cashpointsName={(currentRestaurant?.cashPointsName) || CashPointsDefaultName}
									amount={currentCashpoints.amount}
									transactions={currentCashpoints.transactions}
									onOverlayClick={cancelCashpoints}
								/>)
							}
							{
								popup.includes(OFFERS_POPUP) && (<Offers
									offers={currentCustomer?.customerDiscounts}
									onOverlayClick={cancelOffers}
								/>)
							}
							
							
							{
								popup.includes(PROFILE_POPUP) && (<Profile
									currentCustomer={currentCustomer}
									cashBackPercentage={currentRestaurant?.cashBackPercentage}
									cashpointsAmount={currentCashpoints?.amount}
									cashpointsName={currentRestaurant?.cashPointsName || CashPointsDefaultName}
									isPromotionCodesInApp={currentRestaurant?.isPromotionCodesInApp}
									onPhoneClick={openPhone}
									onNameClick={openName}
									onEmailClick={openEmail}
									onBirthdayClick={openBirthday}
									onCashpointsClick={openCashpoints}
									onOffersClick={openOffers}
									onOverlayClick={cancelProfile}
									onCardClick={() => openCardStatus(currentCustomer?.cardNumber, currentRestaurant.paymentTypes)}
								/>)
							}
							{
								popup.includes(GUEST_ORDER_POPUP) && (<GuestOrderPopup
									currentRestaurant={currentRestaurant}
									error={fetchError[SET_GUEST]}
									isRequestInProgress={fetchProgress[SET_GUEST]}
									phoneCodes={PhoneCodes}
									onCancel={cancelGuestOrderPopup}
									onLogin={openPhone}
									onSignup={openProfile}
									onContinueAsGuest={(name, phone, acceptTerms) => confirmSetGuest(name, phone, acceptTerms)}
								/>)
							}
							{
								popup.includes(INITIAL_ORDER_POPUP) && (<InitialOrderPopup
									currentRestaurant={currentRestaurant}
									error={fetchError[SET_PHONE]}
									isRequestInProgress={fetchProgress[SET_PHONE]}
									phoneCodes={PhoneCodes}
									onCancel={cancelInitialOrderPopup}
									onLogin={(phone) => confirmPhone(phone)}
									onSignup={openProfile}
								/>)
							}
							{
								popup.includes(LOGOUT_CONFIRMATION_POPUP) && (
									<Confirmation
										title={getSafeTranslation('LogoutConfirmationPopup.title', translations)}
										description={getSafeTranslation('LogoutConfirmationPopup.description', translations)}
										onOverlayClick={cancelLogoutConfirmation}
										onNoClick={cancelLogoutConfirmation}
										onYesClick={doneLogoutConfirmation}
									/>
								)
							}
							{
								popup.includes(INCOMPATIBLE_CART_CONFIRMATION_POPUP) && (
									<Confirmation
										title={getSafeTranslation('IncompatibleCartConfirmationPopup.title', translations)}
										description={getSafeTranslation('IncompatibleCartConfirmationPopup.description', translations)}
										onOverlayClick={cancelIncompatibleCartConfirmation}
										onNoClick={cancelIncompatibleCartConfirmation}
										onYesClick={() => doneIncompatibleCartConfirmation(currentRestaurantId)}
									/>
								)
							}
							{
								popup.includes(NOTIFICATIONS_POPUP) && (
									<Notifications
										allowEmail={currentCustomer?.marketing?.allowEmail}
										allowSms={currentCustomer?.marketing?.allowSms}
										onEmailClick={setEmailMarketingConsent}
										onSmsClick={setSmsMarketingConsent}
										onOverlayClick={cancelNotifications}
									/>
								)
							}
							{
								popup.includes(SETTINGS_POPUP) && (<Settings
									isShowLogout={!!currentCustomer?.nickname}
									termsUrl={currentCustomer?.terms?.url}
									appVersion={Config.getAppVersion()}
									activeNotificationsCount={[currentCustomer?.marketing?.allowEmail, currentCustomer?.marketing?.allowSms].filter(value => !!value)?.length}
									language={currentCustomer?.locale && getSafeTranslation(`languageCode${currentCustomer.locale.toUpperCase()}`, translations)}
									onLanguageClick={openSelectLanguage}
									onNotificationClick={openNotifications}
									onOverlayClick={cancelSettings}
									onLogoutClick={openLogoutConfirmation}
									onVersionClick={openDebug}
								/>)
							}
							{
								popup.includes(ORDERS_POPUP) && (<Orders
									currentActiveOrders={currentActiveOrders}
									currentHistoryOrders={currentHistoryOrders}
									isUserLoggedIn={!!currentCustomer?.nickname}
									onOrderClick={orderId => openOrder(orderId)}
									onOverlayClick={cancelOrders}
									onEmailAllReceiptsClick={openEmailAllReceipts}
									onLogInClick={openPhone}
									onOrderAgainClick={(order) => {
										setCurrentOrder(order);
										openRepeatOrderFromHistoryConfirmation()
									}}
								/>)
							}
							{popup.includes(SELECT_LOCATION_POPUP) && (
								<SelectLocation
									currentPosition={location.currentLocation}
									locations={currentFilteredRestaurantList}
									orderingType={orderingMode.orderingType}
									isShowLocationPermissionRequest={isPossibleToRequestLocationPermission(permission.location.status)}
									onLocationPermissionRequestClick={doneLocationPermissionConfirmation}
									onLocationClick={setCurrentRestaurant}
									onOverlayClick={cancelSelectLocation}
								/>
							
							)}
							{
								popup.includes(ZIP_EDIT_POPUP) && (
									<ZipEdit
										error={fetchError[RESTAURANT_LIST_BY_ZIP]}
										onOverlayClick={cancelZipEdit}
										onCancelClick={cancelZipEdit}
										onDoneClick={doneZipEdit}
									/>
								)
							}
							{
								popup.includes(DELIVERY_ADDRESS_POPUP) && (
									<DeliveryAddress
										isRequestInProgress={fetchProgress[RESTAURANT_LIST_BY_ZIP]}
										defaultAddressValue={currentDeliveryAddress?.address}
										defaultPredictionIdValue={currentDeliveryAddress?.predictionId}
										defaultZipValue={currentDeliveryAddress?.zip}
										error={fetchError[RESTAURANT_LIST_BY_ZIP]}
										onOverlayClick={cancelDeliveryAddress}
										onCancelClick={cancelDeliveryAddress}
										onDoneClick={doneDeliveryAddress}
									/>)
							}
							{popup.includes(INITIAL_POPUP) && (
								<Initial
									availableOrderingTypes={availableOrderingTypes}
									currentRestaurant={currentRestaurant}
									isLargeScreen={isLargeScreen}
									onOrderingTypeClick={onOrderingTypeClick}
									onProfileClick={openProfile}
									isShowAddToHomeScreen={isPWAInstallAvailable()}
									onAddToHomeScreenClick={addToHomeScreenFromSettings}
									onSettingsClick={openSettings}
									currentCustomer={currentCustomer}
									currentActiveOrdersCount={currentActiveOrders.length}
									currentCashpoints={currentCashpoints}
									onUserNameClick={openPhone}
									onOffersClick={openOffers}
									onCashpointsClick={openCashpoints}
									onOrdersClick={openOrders}
									onOverlayClick={orderingMode.orderingType ? cancelInitial : undefined}
								/>
							)}
							
							{
								popup.includes(SLOW_SERVICE_POPUP) && (
									<ErrorMessage
										description={getSafeTranslation('SlowServicePopup.description', translations)}
										control={<Button
											isAutoWidth
											onClick={doneSlowServiceCaption}
										>
											{getSafeTranslation('SlowServicePopup.doneCaption', translations)}
										</Button>}
									/>
								)
							}
							
							{
								allergens && <AllergensPopup
									allergens={allergens}
									onOverlayClick={() => setAllergens(null)}
									onDoneClick={() => setAllergens(null)}
								/>
							}
							{
								showServerPopup && currentServerPopups?.length > 0 && <ServerPopupContainer
									popups={currentServerPopups}
									onDoneClick={doneServer}
									onExternalLinkClick={openExternalLink}
									onMenuEntryLinkClick={(mainCategoryId, categoryId, menuEntryId) => {
										setShowServerPopup(false);
										openMenuEntryLink(mainCategoryId, categoryId, menuEntryId);
									}}
									onRestaurantLinkClick={openRestaurantLink}
									onOverlayClick={() => setShowServerPopup(false)}
									currentRestaurantId={currentRestaurantId}
								/>
							}
							
							{!isLargeScreen && popup.includes(MINICART_POPUP) && (
								<DialogOverlay onOverlayClick={cancelMinicart}>
									<Drawer
										onChevronClick={cancelMinicart}
										bottomStaticControl={
											<CheckoutButton
												totalPrice={convertPrice(getCartTotal(currentPurchase, currentServerValues, deliveryConditions, cartItems, tipAmount))}
												onClick={() => onCheckout(currentRestaurantId)}
												isEmpty={
													cartItems.length <= 0
												}
											/>
										}
									>
										{
											cartItems.length > 0 && (
												<CartDisplay
													cartItems={cartItems}
													onQuantityDecClick={token => decOrderLineQuantity(currentRestaurantId, token)}
													onQuantityIncClick={token => incOrderLineQuantity(currentRestaurantId, token)}
													onModifierGroupClick={(modifierGroupId, token) => {
														setEditableCartModifierGroupId(modifierGroupId);
														setEditableCartItemToken(token);
														openCartModifierGroupEdit();
													}}
													discount={getCartDiscount(cartItems, deliveryConditions, currentServerValues)}
													delivery={orderingMode?.orderingType === OrderingTypes.delivery && (deliveryConditions?.price
														|| currentRestaurant?.deliveryPrice || 0)}
													cashpoints={currentPurchase.useCashPoints && currentServerValues.cashpointsAmount}
													cashpointsName={(currentRestaurant?.cashPointsName) || CashPointsDefaultName}
													tip={tipAmount}
													isNoPaddings
												/>
											)
										}
									</Drawer>
								</DialogOverlay>
							)}
							
							{
								popup.includes(MODIFIER_GROUP_EDIT_POPUP) && (
									<ModifierGroupEdit
										modifierGroup={editableModifierGroup}
										modifierGroupSelections={(menuModifierSelections[editableEntryId]
											&& menuModifierSelections[editableEntryId][editableModifierGroupId]) || defaultModifierSelections[editableModifierGroupId]}
										modifierGroupIndex={editableEntry.modIds?.indexOf(editableModifierGroupId)}
										modifierGroupsCount={editableEntry.modIds?.length}
										title={editableEntry.name}
										description={editableEntry.desc}
										onCloseClick={closeModifierGroupEdit}
										onOverlayClick={closeModifierGroupEdit}
										onAddToCartClick={() => {
											onAddToCartFromModifierClick(expandedEntryId, entryQuantities[expandedEntryId] || 1, menuModifierSelections);
										}}
										onNextClick={
											editableEntry.modIds?.indexOf(editableModifierGroupId) < editableEntry.modIds?.length - 1
												? openNextModifierGroupEdit
												: undefined
										}
										onModifierDescriptionClick={onModifierDescriptionClick}
										onModifierChange={(newSelectedModifiers, modifierGroupId) => {
											setMenuModifierSelections({
												...menuModifierSelections,
												[editableEntryId]: {
													...(menuModifierSelections[editableEntryId] || {}),
													[modifierGroupId]: newSelectedModifiers
												}
											});
										}}
									/>
								)
							}
							{
								popup.includes(MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('ModifierValidationErrorMessagePopup.title', translations)}
									description={fetchError[ADD_MENU_ENTRY_TO_CART]}
									onOverlayClick={cancelModifiersValidationErrorMessage}
									control={<Button
										isAutoWidth
										onClick={cancelModifiersValidationErrorMessage}
									>
										{getSafeTranslation('ModifierValidationErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
							{
								popup.includes(RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('RestaurantClosedErrorMessagePopup.title', translations)}
									description={currentCustomer?.restaurant?.isTooBusyForNewOrders
										? getSafeTranslation('RestaurantClosedErrorMessagePopup.tooBusyDescription', translations)
										: getSafeTranslation('RestaurantClosedErrorMessagePopup.closedDescription', translations)}
									onOverlayClick={() => cancelRestaurantClosedErrorMessage()}
									control={<Button
										isAutoWidth
										onClick={() => cancelRestaurantClosedErrorMessage()}
									>
										{getSafeTranslation('RestaurantClosedErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
							{
								popup.includes(MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('MobilePayOrderCancelledErrorMessagePopup.title', translations)}
									description={fetchError[CHECK_PAYMENT_STATUS]}
									onOverlayClick={cancelMobilePayOrderCancelledErrorMessage}
									control={<Button
										isAutoWidth
										onClick={cancelMobilePayOrderCancelledErrorMessage}
									>
										{getSafeTranslation('MobilePayOrderCancelledErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
						</DialogStack>
						<DialogStack>
							{
								popup.includes(REPEAT_ORDER_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('RepeatOrderErrorMessagePopup.title', translations)}
									description={fetchError[REPEAT_ORDER]}
									onOverlayClick={cancelRepeatOrderErrorMessage}
									control={<Button
										isAutoWidth
										onClick={cancelRepeatOrderErrorMessage}
									>
										{getSafeTranslation('RepeatOrderErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
							{
								popup.includes(REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP) &&
								<Confirmation
									title={getSafeTranslation('RepeatOrderConfirmation.title', translations)}
									description={
										getSafeTranslation('RepeatOrderConfirmation.description', translations)
										.replace(/(\{.+?\})/gi, '{b}$1{/b}')
										.replace('{restaurantName}', currentOrder.restaurantName)
										.replace('{orderingType}', getSafeTranslation(RepeatOrderingTypeTranslations[orderingType], translations))
									}
									onOverlayClick={cancelRepeatOrderFromHistoryConfirmation}
									onNoClick={cancelRepeatOrderFromHistoryConfirmation}
									onYesClick={() => doneRepeatOrderFromHistoryConfirmation(currentOrder.orderId)}
								/>
							}
						</DialogStack>
						<DialogStack>
							{
								popup.includes(DEBUG_POPUP) && <Debug
									currentCustomer={currentCustomer}
									onOverlayClick={cancelDebug}
								/>
							}
							{
								popup.includes(EMAIL_ALL_RECEIPTS_POPUP) && (
									<EmailReceipt
										currentCustomer={currentCustomer}
										title={getSafeTranslation('EmailAllReceiptsPopup.title', translations)}
										defaultEmail={currentCustomer.email}
										error={fetchError[EMAIL_RECEIPTS]}
										onOverlayClick={() => cancelEmailAllReceipts()}
										onCancelClick={() => cancelEmailAllReceipts()}
										onDoneClick={(email, isSubscribe) => doneEmailAllReceipts(email, isSubscribe)}
									/>
								)
							}
							{
								fetchMessage[REPEAT_ORDER] && fetchMessage[REPEAT_ORDER].length > 0 && (<ErrorMessage
									description={fetchMessage[REPEAT_ORDER].join('')}
									onOverlayClick={cancelRepeatOrderMessage}
									control={<Button isAutoWidth
																	 onClick={cancelRepeatOrderMessage}>
										{getSafeTranslation('RepeatOrderMessage.buttonCaption', translations)}
									</Button>}
								/>)
							}
							{
								fetchMessage[RESEND_PHONE_CODE] && (<ErrorMessage
									description={fetchMessage[RESEND_PHONE_CODE].join('')}
									onOverlayClick={() => cancelResendVerificationCodeMessage()}
									control={<Button isAutoWidth
																	 onClick={() => cancelResendVerificationCodeMessage()}>{getSafeTranslation(
										'ResendPhoneCodeErrorMessage.buttonCaption', translations)}</Button>}
								/>)
							}
							{
								popup.includes(VERIFICATION_CODE_POPUP) && (<VerificationCode
									isTermsNotAccepted={currentCustomer?.terms?.status === TermsStatuses.NOT_ACCEPTED}
									chainName={currentRestaurant?.chainName}
									phone={currentCustomer?.verificationCodePhone}
									termsUrl={currentCustomer?.terms?.url}
									error={
										(!!fetchError[CHECK_PHONE_CODE] || !!fetchError[RESEND_PHONE_CODE]) && (
											`${fetchError[CHECK_PHONE_CODE] || ''}
                                ${fetchError[RESEND_PHONE_CODE] || ''}`
										)
									}
									isRequestInProgress={fetchProgress[CHECK_PHONE_CODE]}
									onResendClick={() => confirmVerificationCodeResend()}
									onCancelClick={() => cancelVerificationCode()}
									onDoneClick={(phoneCode, termsConsent, marketingConsent) => {
										confirmPhoneCode(phoneCode, termsConsent, marketingConsent, shouldOpenCartOnLogin);
									}}
									onOverlayClick={() => cancelVerificationCode()}
								/>)
							}
							{
								popup.includes(PHONE_POPUP) && (<Phone
									phoneCodes={PhoneCodes}
									error={fetchError[SET_PHONE] || fetchError[CHECK_PHONE_CODE]}
									isRequestInProgress={fetchProgress[SET_PHONE]}
									onCancelClick={() => cancelPhone()}
									onDoneClick={phone => {
										confirmPhone(phone);
									}}
									onOverlayClick={() => cancelPhone()}
								/>)
							}
							{
								popup.includes(NAME_POPUP) && (<Name
									defaultValue={currentCustomer && currentCustomer.nickname}
									error={fetchError[SET_NAME]}
									onDoneClick={name => doneName(name)}
									onOverlayClick={() => cancelName()}
									onCancelClick={() => cancelName()}
								/>)
							}
							{
								popup.includes(EMAIL_POPUP) && (<Email
									defaultValue={currentCustomer && currentCustomer.email}
									error={fetchError[SET_EMAIL]}
									onDoneClick={email => doneEmail(email)}
									onOverlayClick={() => cancelEmail()}
									onCancelClick={() => cancelEmail()}
								/>)
							}
							{
								popup.includes(BIRTHDAY_POPUP) && (<Birthday
									defaultValue={currentCustomer && currentCustomer.birthdate}
									error={fetchError[SET_BIRTHDATE]}
									onDoneClick={birthday => doneBirthday(birthday)}
									onOverlayClick={() => cancelBirthday()}
									onCancelClick={() => cancelBirthday()}
								/>)
							}
							{
								popup.includes(TERMS_POPUP) && (<Terms
									error={fetchError[ACCEPT_TERMS]}
									termsUrl={currentCustomer?.terms?.url}
									isShowMarketingConsent={currentCustomer?.terms?.status === TermsStatuses.NOT_ACCEPTED}
									currentRestaurant={currentRestaurant}
									onExternalLinkClick={openExternalLink}
									onCancelClick={cancelTerms}
									onDoneClick={doneTerms}
								/>)
							}
							{
								popup.includes(PROFILE_STRIPE_CARD_REGISTRATION_POPUP) && (
									<StripeCardRegistration
										stripeKey={payment.stripeKey}
										stripeClientSecret={payment.stripeClientSecret}
										onCancelClick={cancelProfileStripeCardRegistration}
										onOverlayClick={cancelProfileStripeCardRegistration}
										onRegistrationSuccess={() => profileStripeSuccess(currentTemporaryOrderId, currentRestaurantId)}
										onRegistrationError={() => profileStripeError(currentRestaurantId)}
									
									/>
								)
							}
							{
								popup.includes(ADYEN_CARD_REGISTRATION_POPUP) && (
									<AdyenCardRegistration
										currentCardNumber={currentCustomer?.cardNumber}
										adyenClientKey={payment.adyenClientKey}
										adyenPaymentMethodsResponse={payment.adyenPaymentMethodsResponse}
										handleAction={payment.adyenHandleAction}
										onOverlayClick={() => cancelAdyenCardRegistration()}
										onCancelClick={() => cancelAdyenCardRegistration()}
										onSubmit={(state, dropin) => submitAdyenCardRegister(state.data)}
										onAdditionalDetails={(state, dropin) => submitAdyenCardAdditionalDetails(state.data)}/>
								)
							}
							{
								popup.includes(CARD_STATUS_POPUP) && (<CardStatus
									currentCard={currentCustomer?.cardNumber}
									onOverlayClick={cancelCardStatus}
									onCancelClick={cancelCardStatus}
									onDoneClick={() => doneCardStatus(currentRestaurant.paymentTypes)}
								/>)
							}
							{
								popup.includes(SELECT_LANGUAGE_POPUP) && (<SelectLanguage
									languages={currentCustomer?.languages
										? currentCustomer.languages.split(',').map(lang => lang.trim())
										: []}
									defaultLanguage={currentCustomer?.locale}
									onOverlayClick={cancelSelectLanguage}
									onCancelClick={cancelSelectLanguage}
									onDoneClick={language => doneSelectLanguage(language)}
								/>)
							}
							{
								popup.includes(ADD_TO_HOME_SCREEN_POPUP) && isPWAInstallAvailable() && (
									<AddToHomeScreen
										onOverlayClick={cancelAddToHomeScreen}
										onDoneClick={doneAddToHomeScreen}
									/>)
							}
							{
								popup.includes(CART_MODIFIER_GROUP_EDIT_POPUP) && (
									<ModifierGroupEdit
										modifierGroup={editableCartModifierGroup}
										modifierGroupSelections={editableCartItem.modifierSelections[editableCartModifierGroupId]}
										modifierGroupIndex={editableCartItemMenuEntry.modIds?.indexOf(editableCartModifierGroupId)}
										modifierGroupsCount={editableCartItemMenuEntry.modIds?.length}
										title={editableCartItemMenuEntry.name}
										description={editableCartItemMenuEntry.desc}
										onCloseClick={closeCartModifierGroupEdit}
										onOverlayClick={closeCartModifierGroupEdit}
										onNextClick={
											editableCartItemMenuEntry.modIds?.indexOf(editableCartModifierGroupId) < editableCartItemMenuEntry.modIds?.length - 1
												? openNextCartModifierGroupEdit
												: closeCartModifierGroupEdit
										}
										onModifierChange={(newSelectedModifiers, modifierGroupId) => {
											changeOrderLineModifiers(
												currentRestaurantId,
												editableCartItemToken,
												modifierGroupId,
												newSelectedModifiers
											);
										}}
									/>
								)
							},
							{popup.includes(DISCOUNT_ERROR_MESSAGE_POPUP) && (
								<ErrorMessage
									title={getSafeTranslation("DiscountErrorMessagePopup.title", translations)}
									description={fetchError[DISCOUNT]}
									onOverlayClick={() => {
										cancelDiscountErrorMessage();
										if (currentRestaurant?.isFutureOrdersAllowed && showPickupTimePopupOrderingClosed(fetchError[DISCOUNT])) {
											setPickupTimePopupOpen(true);
										}
									}
									}
									control={
										<Button isAutoWidth onClick={() => {
											cancelDiscountErrorMessage();
											if (currentRestaurant?.isFutureOrdersAllowed && showPickupTimePopupOrderingClosed(fetchError[DISCOUNT])) {
												setPickupTimePopupOpen(true);
											}
										}
										}>
											{getSafeTranslation("DiscountErrorMessagePopup.buttonCaption", translations)}
										</Button>
									}
								/>
							)}
						</DialogStack>
						
						<DialogStack>
							{
								modifierDescription && <ModifierDescription
									description={modifierDescription}
									onDoneClick={() => setModifierDescription(null)}
									onOverlayClick={() => setModifierDescription(null)}
								/>
							}
						</DialogStack>
						
						<DialogStack>
							{
								popup.includes(MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('MobilePayReturnNoStateErrorMessagePopup.title', translations)}
									description={getSafeTranslation('MobilePayReturnNoStateErrorMessagePopup.description', translations)}
									onOverlayClick={cancelMobilePayReturnNoStateErrorMessage}
									control={<Button
										isAutoWidth
										onClick={doneMobilePayReturnNoStateErrorMessage}
									>
										{getSafeTranslation('MobilePayReturnNoStateErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
							{
								popup.includes(MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('MobilePayReturnNoUrlErrorMessagePopup.title', translations)}
									description={getSafeTranslation('MobilePayReturnNoUrlErrorMessagePopup.description', translations)}
									description2={getSafeTranslation("MobilePayReturnNoUrlErrorMessagePopup.description2", translations)}
									onOverlayClick={cancelMobilePayReturnNoUrlErrorMessage}
									control={<Button
										isAutoWidth
										onClick={cancelMobilePayReturnNoUrlErrorMessage}
									>
										{getSafeTranslation('MobilePayReturnNoUrlErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
							{
								popup.includes(ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('AdyenCardCheckPaymentErrorMessagePopup.title', translations)}
										description={fetchError[CHECK_ADYEN_PAYMENT]}
										onOverlayClick={cancelAdyenCardCheckPaymentErrorMessagePopup}
										control={<Button
											isAutoWidth
											onClick={cancelAdyenCardCheckPaymentErrorMessagePopup}
										>
											{getSafeTranslation('AdyenCardCheckPaymentErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
						</DialogStack>
						<DialogStack>
							{
								popup.includes(CAUTH_CLEAR_CUSTOMER_DATA_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('CauthClearCustomerDataPopup.title', translations)}
										description={getSafeTranslation('CauthClearCustomerDataPopup.description', translations)}
										control={<Button
											isAutoWidth
											onClick={doneCauthClearCustomerData}
										>
											{getSafeTranslation('CauthClearCustomerDataPopup.doneButtonCaption', translations)}
										</Button>}
									/>
								)
							}
						</DialogStack>
						<DialogStack>
							{
								popup.includes(ADYEN_MOBILE_PAY_ANONYMOUS_INFO_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('AdyenMobilePayAnonymousPopup.title', translations)}
										description={getSafeTranslation('AdyenMobilePayAnonymousPopup.description', translations)}
										control={<Button
											isAutoWidth
											onClick={doneMobilePayAnonymousInfo}
										>
											{getSafeTranslation('AdyenMobilePayAnonymousPopup.doneButtonCaption', translations)}
										</Button>}
									/>
								)
							}
						</DialogStack>
						<DialogStack>
							{
								connectivity.isOnline === false && <Offline
								/>
							}
							{
								fetchError[SERVER_CONFIG] && (<ErrorMessage
									description={fetchError[SERVER_CONFIG]}
								/>)
							}
						</DialogStack>
					
					
					</DialogManager>
					{
						loading.isShowing && <LoadingSpinner style={loading.style}/>
					}
				</div>
			</Layout>
		</TranslationsContext.Provider>
	);
};

const mapStateToProps = state => {
	return {
		currentAppId: getCurrentAppIdSelector(state),
		currentRestaurantId: getCurrentRestaurantIdSelector(state),
		currentRestaurant: getCurrentRestaurantSelector(state),
		currentCustomer: getCurrentCustomerSelector(state),
		currentMenu: getCurrentMenuSelector(state),
		currentPurchase: getCurrentPurchaseSelector(state),
		currentRestaurantList: getCurrentRestaurantListSelector(state),
		currentFilteredRestaurantList: getCurrentFilteredRestaurantListSelector(state),
		cartItems: getCartItemsSelector(state),
		orderingMode: state.orderingMode,
		currentActiveOrders: getCurrentActiveOrdersSelector(state),
		currentHistoryOrders: getCurrentHistoryOrdersSelector(state),
		currentCashpoints: getCurrentCashpointsSelector(state),
		fetchError: state.fetchError,
		fetchProgress: state.fetchProgress,
		fetchMessage: state.fetchMessage,
		popup: state.popup,
		currentServerValues: getCurrentServerValuesSelector(state),
		currentDeliveryAddress: getCurrentDeliveryAddressSelector(state),
		deliveryConditions: getDeliveryConditionsSelector(state),
		availableOrderingTypes: getAvailableOrderingTypesSelector(state),
		currentServerConfig: getCurrentServerConfig(state),
		connectivity: state.connectivity,
		orderTime: state.orderTime,
		translations: getTranslationsSelector(state),
		payment: state.payment,
		permission: state.permission,
		location: state.location,
		tipAmount: getTipAmountSelector(state),
		pwaPrompt: state.pwaPrompt,
		loading: state.loading,
		currentServerPopups: getCurrentServerPopupsSelector(state),
		currentTemporaryOrderId: getCurrentTemporaryOrderIdSelector(state),
		defaultTakeAwayItemsAdded: getCurrentDefaultTakeAwayItemsAddedSelector(state),
		currentGuest: getCurrentGuestSelector(state),
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setOrderTypeInitial: (orderType, restaurantsList) => dispatch(setOrderTypeInitial(orderType, restaurantsList)),
		setCurrentRestaurant: restaurantId => dispatch(setCurrentRestaurant(restaurantId)),
		addMenuEntryToCart: (
			restaurantId,
			menuEntryId,
			quantity,
			selectedModifierIds,
			blockingPopup,
			postponingPopup,
			modifierValidationErrors,
			isDefaultTakeAwayItem,
		) => dispatch(addMenuEntryToCart(
			restaurantId,
			menuEntryId,
			quantity,
			selectedModifierIds,
			blockingPopup,
			postponingPopup,
			modifierValidationErrors,
			isDefaultTakeAwayItem
		)),
		incOrderLineQuantity: (restaurantId, token) => dispatch(incOrderLineQuantity(restaurantId, token)),
		decOrderLineQuantity: (restaurantId, token) => dispatch(decOrderLineQuantity(restaurantId, token)),
		confirmPhone: phone => dispatch(confirmPhone(phone)),
		confirmPhoneCode: (phoneCode, termsConsent, marketingConsent, shouldOpenCartOnLogin) => dispatch(confirmPhoneCode(phoneCode, termsConsent, marketingConsent, shouldOpenCartOnLogin)),
		selectLanguage: locale => dispatch(selectLanguage(locale)),
		openSelectLocation: () => dispatch(openSelectLocation()),
		cancelSelectLocation: () => dispatch(cancelSelectLocation()),
		cancelDiscountErrorMessage: () => dispatch(cancelDiscountErrorMessage()),
		openMinicart: () => dispatch(openMinicart()),
		cancelMinicart: () => dispatch(cancelMinicart()),
		openPhone: () => dispatch(openPhone()),
		cancelPhone: () => dispatch(cancelPhone()),
		cancelVerificationCode: () => dispatch(cancelVerificationCode()),
		confirmVerificationCodeResend: () => dispatch(confirmVerificationCodeResend()),
		openOrders: (restaurantId) => dispatch(openOrders(restaurantId)),
		cancelOrders: () => dispatch(cancelOrders()),
		openProfile: () => dispatch(openProfile()),
		cancelProfile: () => dispatch(cancelProfile()),
		openSettings: () => dispatch(openSettings()),
		cancelSettings: () => dispatch(cancelSettings()),
		openName: () => dispatch(openName()),
		cancelName: () => dispatch(cancelName()),
		doneName: name => dispatch(doneName(name)),
		openEmail: () => dispatch(openEmail()),
		cancelEmail: () => dispatch(cancelEmail()),
		doneEmail: email => dispatch(doneEmail(email)),
		openBirthday: () => dispatch(openBirthday()),
		cancelBirthday: () => dispatch(cancelBirthday()),
		doneBirthday: (birthday) => dispatch(doneBirthday(birthday)),
		openOffers: () => dispatch(openOffers()),
		cancelOffers: () => dispatch(cancelOffers()),
		openCashpoints: () => dispatch(openCashpoints()),
		cancelCashpoints: () => dispatch(cancelCashpoints()),
		openSelectLanguage: () => dispatch(openSelectLanguage()),
		cancelSelectLanguage: () => dispatch(cancelSelectLanguage()),
		doneSelectLanguage: (language) => dispatch(doneSelectLanguage(language)),
		openInitial: () => dispatch(openInitial()),
		cancelInitial: () => dispatch(cancelInitial()),
		openModifierGroupEdit: () => dispatch(openModifierGroupEdit()),
		cancelModifierGroupEdit: () => dispatch(cancelModifierGroupEdit()),
		openCartModifierGroupEdit: () => dispatch(openCartModifierGroupEdit()),
		cancelCartModifierGroupEdit: () => dispatch(cancelCartModifierGroupEdit()),
		changeOrderLineModifiers: (restaurantId, token, modifierGroupId, selectedModifierIds) => dispatch(
			changeOrderLineModifiers(restaurantId, token, modifierGroupId, selectedModifierIds)),
		cancelDeliveryAddress: () => dispatch(cancelDeliveryAddress()),
		doneDeliveryAddress: (address, zip, location, predictionId, isCheckDeliveryAddress) => dispatch(doneDeliveryAddress(address, zip, location, predictionId, isCheckDeliveryAddress)),
		checkout: (restaurantId) => dispatch(checkout(restaurantId)),
		cancelZipEdit: () => dispatch(cancelZipEdit()),
		doneZipEdit: zip => dispatch(doneZipEdit(zip)),
		openDeleteCard: () => dispatch(openDeleteCard()),
		cancelRestaurantClosedErrorMessage: () => dispatch(cancelRestaurantClosedErrorMessage()),
		openLogoutConfirmation: () => dispatch(openLogoutConfirmation()),
		cancelLogoutConfirmation: () => dispatch(cancelLogoutConfirmation()),
		doneLogoutConfirmation: () => dispatch(doneLogoutConfirmation()),
		openEmailAllReceipts: () => dispatch(openEmailAllReceipts()),
		cancelEmailAllReceipts: () => dispatch(cancelEmailAllReceipts()),
		doneEmailAllReceipts: (email, isSubscribe) => dispatch(doneEmailAllReceipts(email, isSubscribe)),
		cancelResendVerificationCodeMessage: () => dispatch(cancelResendVerificationCodeMessage()),
		cancelModifiersValidationErrorMessage: () => dispatch(cancelModifiersValidationErrorMessage()),
		openNotifications: () => dispatch(openNotifications()),
		cancelNotifications: () => dispatch(cancelNotifications()),
		setEmailMarketingConsent: (newEmailMarketingConsent) => dispatch(setEmailMarketingConsent(newEmailMarketingConsent)),
		setSmsMarketingConsent: (newSmsMarketingConsent) => dispatch(setSmsMarketingConsent(newSmsMarketingConsent)),
		openCardStatus: (currentCardNumber, paymentTypes) => dispatch(openCardStatus(currentCardNumber, paymentTypes)),
		cancelCardStatus: () => dispatch(cancelCardStatus()),
		doneCardStatus: (paymentTypes) => dispatch(doneCardStatus(paymentTypes)),
		openDebug: () => dispatch(openDebug()),
		cancelDebug: () => dispatch(cancelDebug()),
		cancelIncompatibleCartConfirmation: () => dispatch(cancelIncompatibleCartConfirmation()),
		doneIncompatibleCartConfirmation: (currentRestaurantId) => dispatch(doneIncompatibleCartConfirmation(currentRestaurantId)),
		cancelProfileStripeCardRegistration: () => dispatch(cancelProfileStripeCardRegistration()),
		profileStripeSuccess: (orderId, restaurantId) => dispatch(profileStripeSuccess(orderId, restaurantId)),
		profileStripeError: (restaurantId) => dispatch(profileStripeError(restaurantId)),
		cancelTerms: () => dispatch(cancelTerms()),
		doneTerms: (termsConsent, marketingConsent) => dispatch(doneTerms(termsConsent, marketingConsent)),
		openLocationPermissionConfirmation: () => dispatch(openLocationPermissionConfirmation()),
		cancelLocationPermissionConfirmation: () => dispatch(cancelLocationPermissionConfirmation()),
		doneLocationPermissionConfirmation: () => dispatch(doneLocationPermissionConfirmation()),
		addToHomeScreenFromSettings: () => dispatch(addToHomeScreenFromSettings()),
		doneAddToHomeScreen: () => dispatch(doneAddToHomeScreen()),
		cancelAddToHomeScreen: () => dispatch(cancelAddToHomeScreen()),
		doneServer: (popupId) => dispatch(doneServerPopup(popupId)),
		openExternalLink: (url) => dispatch(openExternalLink(url)),
		openRestaurantLink: (restaurantId) => dispatch(openRestaurantLink(restaurantId)),
		openMenuEntryLink: (mainCategoryId, categoryId, menuEntryId) => dispatch(openMenuEntryLink(mainCategoryId, categoryId, menuEntryId)),
		openOrder: (orderId) => dispatch(openOrder(orderId)),
		cancelRepeatOrderMessage: () => dispatch(cancelRepeatOrderMessage()),
		openRepeatOrderFromHistoryConfirmation: () => dispatch(openRepeatOrderFromHistoryConfirmation()),
		cancelRepeatOrderFromHistoryConfirmation: () => dispatch(cancelRepeatOrderFromHistoryConfirmation()),
		doneRepeatOrderFromHistoryConfirmation: (orderId) => dispatch(doneRepeatOrderFromHistoryConfirmation(orderId)),
		cancelRepeatOrderErrorMessage: () => dispatch(cancelRepeatOrderErrorMessage()),
		cancelMobilePayOrderCancelledErrorMessage: () => dispatch(cancelMobilePayOrderCancelledErrorMessage()),
		cancelMobilePayReturnNoStateErrorMessage: () => dispatch(cancelMobilePayReturnNoStateErrorMessage()),
		doneMobilePayReturnNoStateErrorMessage: () => dispatch(doneMobilePayReturnNoStateErrorMessage()),
		cancelMobilePayReturnNoUrlErrorMessage: () => dispatch(cancelMobilePayReturnNoUrlErrorMessage()),
		submitAdyenCardRegister: (data) => dispatch(submitAdyenCardRegister(data, false)),
		submitAdyenCardAdditionalDetails: (data) => dispatch(submitAdyenCardAdditionalDetails(data, false)),
		cancelAdyenCardRegistration: () => dispatch(cancelAdyenCardRegistration()),
		cancelAdyenCardCheckPaymentErrorMessagePopup: () => dispatch(cancelAdyenCardCheckPaymentErrorMessagePopup()),
		doneCauthClearCustomerData: () => dispatch(doneCauthClearCustomerData()),
		doneMobilePayAnonymousInfo: () => dispatch(doneMobilePayAnonymousInfo()),
		doneSlowServiceCaption: () => dispatch(doneSlowServiceCaption()),
		setPickerDate: date => dispatch(setPickerDate(date)),
		setPickupDateTime: (date, time) => dispatch(setPickupDateTime(date, time)),
		openGuestOrderPopup: () => dispatch(openGuestOrderPopup()),
		cancelGuestOrderPopup: () => dispatch(cancelGuestOrderPopup()),
		confirmSetGuest: (name, phone, acceptTerms) => dispatch(confirmSetGuest(name, phone, acceptTerms)),
		openInitialOrderPopup: () => dispatch(openInitialOrderPopup()),
		cancelInitialOrderPopup: () => dispatch(cancelInitialOrderPopup()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantPage);
